import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";

import * as ResourceApi from "api/resources";
import { enUSmessage } from "i18n/en-US.js";

export default {
  subSection: true,
  resource: false,
  hideIfResourceIsNoU: false,
  showSection: (formProxy) => {
    return formProxy.currentResource.type === "BEAKER2";
  },

  fields: [
    {
        type: 'dropdown',
        name: 'stepType',
        required: true,
        props: {
            labelKey: 'Step Type',
            options: [
                {
                    value: null,
                    textKey: 'Select Step Type'
                },
                {
                    value: 'INCOMM',
                    textKey: 'Incomm'
                },
                {
                    value: 'GEN_AI_TIPS',
                    textKey: 'Gen AI - Tips and Tricks'
                },
                {
                  value: 'PUCK',
                  textKey: 'Puck'
                },
                {
                  value: 'FORM',
                  textKey: 'Form'
                },
                {
                  value: 'SIDE_BY_SIDE_VIDEO',
                  textKey: 'Side by Side Video'
                },
                {
                  value: 'IMAGE_ENHANCEMENT',
                  textKey: 'AI Image Enhancement'
                },
                {
                  value: 'PROMO',
                  textKey: 'Promo'
                },
                {
                  value: 'PRODUCT_SCAN',
                  textKey: 'Product Scan'
                }
            ],
        }
    },
    {
      type: "text",
      name: "stepId",
      required: true,
      props: {
        labelKey: "editbreak.steps.beaker2.step_id",
        placeholderKey: "editbreak.steps.beaker2.step_id.placeholder",
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/beaker2.js